import { Component } from '@angular/core';
import { Data, DataLoaderService, Subscription, ResetService, PriceCalculationService, ProgressBarService } from '../expert-service-call.index';
@Component({
	selector: 'expert-additional-color-options',
	templateUrl: './expert-additional-color.template.html',
	styleUrls: ['./expert-additional-color.component.css']
})
export class ExpertAdditionalColorOptions {
	public addColorOptions = [];
	public addColorKeyValues: String[] = [];;
	public expAddColor: Data[];
	public selected: Data[] = [];
	public retained = [];
	public expertAddColorOptions: any;
	public subscription: Subscription;
	public templastAddColor:any;
	constructor(private dataLoaderService: DataLoaderService, private resetService: ResetService,
		private priceCalculationService: PriceCalculationService, private progressService: ProgressBarService) {
		this.addColorOptions = this.dataLoaderService.data.additionalColor;
		// for (let index = 0; index < this.addColorOptions.length; index++) {
		// 	this.addColorKeyValues.push(((this.addColorOptions[index].code + " - " + this.addColorOptions[index].description)));
		// }
	}
	ngOnInit() {
		//Retention Service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalAddColor") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					if(!this.dataLoaderService.flagDictionary.undoActivatedForAddColor){
						this.dataLoaderService.previousAddColorExp = selectedOption.data[0].code;
					}
				} else {
					this.selected = [];
					if(!this.dataLoaderService.flagDictionary.undoActivatedForAddColor){
						this.dataLoaderService.previousAddColorExp = [];
					}
				}
				this.progressService.progressBarValidation();
			}
		});
		// for undo alternative option
		
		this.priceCalculationService.notifyObservableExpertCompLastItem$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertAddColor") {
				if (selectedOption.data[0] != undefined) {
					this.selected = selectedOption.data[0].code;
					this.dataLoaderService.previousAddColorExp = selectedOption.data[0].code;
				} else {
					this.selected = [];
					this.dataLoaderService.previousAddColorExp=[];
				}
				
				this.dataLoaderService.flagDictionary.undoActivatedForAddColor= false;
				this.dataLoaderService.flagDictionary.undoActivated= false;
				
				this.progressService.progressBarValidation();
				
			}
		});
		// Undo - End
		//On load	
		let addColor;
		this.addColorOptions.forEach(element => {
			if (element.selected === true) {
				addColor = element;
				this.dataLoaderService.previousExpertAddColor = addColor;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [addColor] });
			}
		});

		//Reset
		this.subscription = this.resetService.notifyObservable$.subscribe(() => {
			this.selected = this.resetService.expAddColor;
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: this.resetService.expAddColor });
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: this.resetService.expAddColor });
			this.priceCalculationService.expertModePriceCalculation();

		});
	}

	ngAfterContentChecked() {
		this.addColorKeyValues = [];
		for (let index = 0; index < this.addColorOptions.length; index++) {
			if (this.addColorOptions[index].selected === false) {
				this.addColorKeyValues.push(((this.addColorOptions[index].code + " - " + this.addColorOptions[index].description)));
			}

		}

		for (let j = 0; j < this.addColorKeyValues.length; j++) {
			if (this.selected != undefined) {
				for (let i = 0; i < this.selected.length; i++) {

					let item = this.addColorKeyValues[j].substring(0, this.addColorKeyValues[j].indexOf(' - '));
					let temp = this.selected[i] + "";
					if (item === temp) {

						this.addColorKeyValues.splice(Number(j), 1);
					}
				}
			}

		}
	}

	clearOptions() {
		this.expertAddColorOptions = null;
	}
	// Set flags to activate undo 
	undoActivate(){
		// for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForAddColor= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
	}
	//adds selected additional color
	onAddColorOptionClick(item) {
		this.undoActivate() //undo activate
		// this.dataLoaderService.expertRemovedCodes.push(this.dataLoaderService.previousExpertAddColor[0]);
		// this.dataLoaderService.previousExpertAddColor = [];
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let adColorCode;
		adColorCode = item.substr(0, 3);
		// this.dataLoaderService.expAdd.push(adColorCode);
		this.selected = adColorCode;
		this.dataLoaderService.flagDictionary.expertValidateFlag = true;
		this.dataLoaderService.flagDictionary.expertvalidated = false;
		for (let i in this.addColorOptions) {
			if (this.addColorOptions[i].code === adColorCode) {
				this.expAddColor = this.addColorOptions[i];
				this.dataLoaderService.selectedAddColor = this.addColorOptions[i];
				// this.dataLoaderService.previousExpertAddColor = this.addColorOptions[i];
				this.addColorOptions[i].selected = true;
			} else {
				this.addColorOptions[i].selected = false;
			}
		}
		// For expert added codes
		// for (let i in this.addColorOptions) {
		// 	for (let j in this.dataLoaderService.expAdd){
		// 		if (item != this.dataLoaderService.previousAddColorExp 
		// 			&& this.addColorOptions[i].code == this.dataLoaderService.expAdd[j] 
		// 			&& !this.addColorOptions[i].selected) {
		// 				this.dataLoaderService.expAdd.splice(Number(j),1);
		// 		}
		// 		if(this.dataLoaderService.expAdd[j]==this.dataLoaderService.previousAddColorExp){
		// 			this.dataLoaderService.expAdd.splice(Number(j),1);
		// 		}
		// 	}
			
		// }
		// // For expert remove codes
		// for (let k in this.dataLoaderService.expertRemovedCodes){
		// 	if(adColorCode == this.dataLoaderService.previousAddColorExp
		// 		&& adColorCode == this.dataLoaderService.expertRemovedCodes[k].code){
		// 		this.dataLoaderService.expertRemovedCodes.splice(Number(k),1);
		// 	}
		// }
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: [this.expAddColor] });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.expAddColor] });
		this.priceCalculationService.expertModePriceCalculation();
		this.progressService.progressBarValidation();
		
	}



	// removes the selected additional color
	deleteSelExpAddColor(item) {
		this.undoActivate() //undo activate
		this.dataLoaderService.flagDictionary.closeFlag = false;
		let adColorCode;
		adColorCode = item.substr(0, 3);
		this.selected = [];
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertAddColor", data: this.selected });
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: this.selected });
		let selcFacForRem = [];
		for (let k in this.addColorOptions) {
			if (this.addColorOptions[k].selected) {
				selcFacForRem.push(this.addColorOptions[k]);
			}
		}
		this.priceCalculationService.notifyExpertCompForRemoved({ fromComponent: "expertAddColor", data: [selcFacForRem] });
		for (let i in this.addColorOptions) {
			if (this.addColorOptions[i].code === adColorCode) {
				// this.dataLoaderService.expertRemovedCodes.push(this.addColorOptions[i]);
				this.addColorOptions[i].selected = false;
				this.dataLoaderService.flagDictionary.expertValidateFlag = true;
				//this.dataLoaderService.flagDictionary.expertvalidated = false;
			}
		}
		// For expert removed codes
		// for (let i in this.addColorOptions) {
		// 	// for (let j in this.dataLoaderService.expertRemovedCodes){
		// 		if ((this.dataLoaderService.previousAddColorExp==undefined 
		// 			|| adColorCode == this.dataLoaderService.previousAddColorExp) 
		// 			&& adColorCode == this.addColorOptions[i].code) {
		// 				this.dataLoaderService.expertRemovedCodes.push(this.addColorOptions[i]);
		// 		}
		// 	// }
		// }
		this.priceCalculationService.expertModePriceCalculation();

		this.progressService.progressBarValidation();
		
	}
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-additional-color/expert-additional-color.component.ts